import { ReportData } from '../types/reportTypes';

// February 2026 Sales Data - Standard Report (22 jobs from Sales CSV)
// Trade names: "ROI " prefix stripped, multi-trade entries use first trade only
const jobData = [
  {
    jobInfo: "E-867: Geneva & Brenda Hall",
    leadSource: "Angi",
    trade: "Insulation",
    contractTotal: 9221.00,
    grossMarginPct: 0.6465,
    grossProfit: 5961.38,
    commissionPercentage: 10.00,
    salesCommission: 922.10,
    salesManagerFee: 92.21,
    companyOH: 1429.26,
    netProfit: 0
  },
  {
    jobInfo: "E-881: Mike & Sarah Brown",
    leadSource: "Yelp",
    trade: "Roofing",
    contractTotal: 12722.00,
    grossMarginPct: 0.4382,
    grossProfit: 5574.78,
    commissionPercentage: 4.00,
    salesCommission: 508.88,
    salesManagerFee: 127.22,
    companyOH: 1971.91,
    netProfit: 0
  },
  {
    jobInfo: "E-864: Nadiah Rodriguez",
    leadSource: "Thumbtack",
    trade: "Windows & Doors",
    contractTotal: 29472.00,
    grossMarginPct: 0.4390,
    grossProfit: 12938.21,
    commissionPercentage: 4.00,
    salesCommission: 1178.88,
    salesManagerFee: 294.72,
    companyOH: 4568.16,
    netProfit: 0
  },
  {
    jobInfo: "E-856: Regina Day",
    leadSource: "Angi",
    trade: "Attic Insulation",
    contractTotal: 5462.00,
    grossMarginPct: 0.6137,
    grossProfit: 3352.03,
    commissionPercentage: 10.00,
    salesCommission: 546.20,
    salesManagerFee: 54.62,
    companyOH: 846.61,
    netProfit: 0
  },
  {
    jobInfo: "E-861: Alison Elkins",
    leadSource: "Thumbtack",
    trade: "Insulation",
    contractTotal: 11406.00,
    grossMarginPct: 0.4114,
    grossProfit: 4692.43,
    commissionPercentage: 4.00,
    salesCommission: 456.24,
    salesManagerFee: 114.06,
    companyOH: 1767.93,
    netProfit: 0
  },
  {
    jobInfo: "E-899: Shirley & Bonnie Knight Carter",
    leadSource: "Events Division",
    trade: "Siding",
    contractTotal: 65551.00,
    grossMarginPct: 0.4000,
    grossProfit: 26220.40,
    commissionPercentage: 4.00,
    salesCommission: 2622.04,
    salesManagerFee: 655.51,
    companyOH: 10160.41,
    netProfit: 0
  },
  {
    jobInfo: "E-866: Chasity & Teman Mebane",
    leadSource: "Google Organic Search",
    trade: "Gutters",
    contractTotal: 12621.00,
    grossMarginPct: 0.5603,
    grossProfit: 7071.55,
    commissionPercentage: 7.00,
    salesCommission: 883.47,
    salesManagerFee: 126.21,
    companyOH: 1956.26,
    netProfit: 0
  },
  {
    jobInfo: "E-875: Christopher & Holi Ray",
    leadSource: "Google Organic Search",
    trade: "Windows & Doors",
    contractTotal: 25697.85,
    grossMarginPct: 0.5684,
    grossProfit: 14606.66,
    commissionPercentage: 7.00,
    salesCommission: 1798.85,
    salesManagerFee: 256.98,
    companyOH: 3983.17,
    netProfit: 0
  },
  {
    jobInfo: "E-885: Keshav & Gabrielle Swaminathan",
    leadSource: "Yelp",
    trade: "Roofing",
    contractTotal: 19666.25,
    grossMarginPct: 0.5174,
    grossProfit: 10175.32,
    commissionPercentage: 7.00,
    salesCommission: 1376.64,
    salesManagerFee: 196.66,
    companyOH: 3048.27,
    netProfit: 0
  },
  {
    jobInfo: "E-882: Jacqueline Harrison",
    leadSource: "Networx",
    trade: "Gutters",
    contractTotal: 11755.00,
    grossMarginPct: 0.4933,
    grossProfit: 5798.74,
    commissionPercentage: 4.00,
    salesCommission: 470.20,
    salesManagerFee: 117.55,
    companyOH: 1822.03,
    netProfit: 0
  },
  {
    jobInfo: "E-900: Shenelle L Williams",
    leadSource: "eLocal",
    trade: "Gutters",
    contractTotal: 16883.40,
    grossMarginPct: 0.4628,
    grossProfit: 7813.64,
    commissionPercentage: 4.00,
    salesCommission: 675.34,
    salesManagerFee: 168.83,
    companyOH: 2616.93,
    netProfit: 0
  },
  {
    jobInfo: "E-883: Christopher Beatty",
    leadSource: "Google Organic Search",
    trade: "Roofing",
    contractTotal: 14912.00,
    grossMarginPct: 0.5032,
    grossProfit: 7503.72,
    commissionPercentage: 7.00,
    salesCommission: 1043.84,
    salesManagerFee: 149.12,
    companyOH: 2311.36,
    netProfit: 0
  },
  {
    jobInfo: "E-884: Ed & Emily Mcgill",
    leadSource: "Thumbtack",
    trade: "Windows & Doors",
    contractTotal: 5872.00,
    grossMarginPct: 0.2820,
    grossProfit: 1655.90,
    commissionPercentage: 0.00,
    salesCommission: 0.00,
    salesManagerFee: 58.72,
    companyOH: 910.16,
    netProfit: 0
  },
  {
    jobInfo: "E-893: John Papiano",
    leadSource: "RoofHero",
    trade: "Roofing",
    contractTotal: 6655.82,
    grossMarginPct: 0.5168,
    grossProfit: 3439.73,
    commissionPercentage: 7.00,
    salesCommission: 465.91,
    salesManagerFee: 66.56,
    companyOH: 1031.65,
    netProfit: 0
  },
  {
    jobInfo: "E-890: Lillian & Theodore Tritle",
    leadSource: "Angi",
    trade: "Roofing",
    contractTotal: 18197.00,
    grossMarginPct: 0.5062,
    grossProfit: 9211.32,
    commissionPercentage: 7.00,
    salesCommission: 1273.79,
    salesManagerFee: 181.97,
    companyOH: 2820.54,
    netProfit: 0
  },
  {
    jobInfo: "E-892: Jeff & Lisa Brown",
    leadSource: "Google Organic Search",
    trade: "Roofing",
    contractTotal: 8221.00,
    grossMarginPct: 0.4000,
    grossProfit: 3288.40,
    commissionPercentage: 4.00,
    salesCommission: 328.84,
    salesManagerFee: 82.21,
    companyOH: 1274.26,
    netProfit: 0
  },
  {
    jobInfo: "E-903: Simon & Melanie Hill",
    leadSource: "Google Paid Search",
    trade: "Roofing",
    contractTotal: 10212.00,
    grossMarginPct: 0.4039,
    grossProfit: 4124.63,
    commissionPercentage: 4.00,
    salesCommission: 408.48,
    salesManagerFee: 102.12,
    companyOH: 1582.86,
    netProfit: 0
  },
  {
    jobInfo: "E-894: Markeita Conway",
    leadSource: "Web to Lead Form",
    trade: "Roofing",
    contractTotal: 13496.00,
    grossMarginPct: 0.5143,
    grossProfit: 6940.99,
    commissionPercentage: 7.00,
    salesCommission: 944.72,
    salesManagerFee: 134.96,
    companyOH: 2091.88,
    netProfit: 0
  },
  {
    jobInfo: "E-897: Sharon Mack",
    leadSource: "Google Paid Search",
    trade: "Windows & Doors",
    contractTotal: 10142.00,
    grossMarginPct: 0.6367,
    grossProfit: 6457.41,
    commissionPercentage: 10.00,
    salesCommission: 1014.20,
    salesManagerFee: 101.42,
    companyOH: 1572.01,
    netProfit: 0
  },
  {
    jobInfo: "E-851: Brett & Saranna Ramsay",
    leadSource: "Events Division",
    trade: "Windows & Doors",
    contractTotal: 16500.00,
    grossMarginPct: 0.4000,
    grossProfit: 6600.00,
    commissionPercentage: 4.00,
    salesCommission: 660.00,
    salesManagerFee: 165.00,
    companyOH: 2557.50,
    netProfit: 0
  },
  {
    jobInfo: "E-898: Sean Keaveney",
    leadSource: "Google Organic Search",
    trade: "Windows & Doors",
    contractTotal: 6663.00,
    grossMarginPct: 0.4307,
    grossProfit: 2869.75,
    commissionPercentage: 4.00,
    salesCommission: 266.52,
    salesManagerFee: 66.63,
    companyOH: 1032.77,
    netProfit: 0
  },
  {
    jobInfo: "E-896: Karen & Steve Saks",
    leadSource: "Google Organic Search",
    trade: "Gutters",
    contractTotal: 5439.68,
    grossMarginPct: 0.3935,
    grossProfit: 2140.51,
    commissionPercentage: 0.00,
    salesCommission: 0.00,
    salesManagerFee: 54.40,
    companyOH: 843.15,
    netProfit: 0
  }
];

// Apply business logic to calculate net profit (Standard Report formula)
jobData.forEach(job => {
  // For Standard Reports: Net Profit = Gross Profit - (Sales Commission + Sales Manager Fee + Company OH)
  job.netProfit = job.grossProfit - (job.salesCommission + job.salesManagerFee + job.companyOH);
});

// Calculate totals
const totalContractValue = jobData.reduce((sum, job) => sum + job.contractTotal, 0);
const totalGrossProfit = jobData.reduce((sum, job) => sum + job.grossProfit, 0);
const totalSalesCommissions = jobData.reduce((sum, job) => sum + job.salesCommission, 0);
const totalManagerFees = jobData.reduce((sum, job) => sum + job.salesManagerFee, 0);
const totalCompanyOH = jobData.reduce((sum, job) => sum + job.companyOH, 0);
const totalNetProfit = jobData.reduce((sum, job) => sum + job.netProfit, 0);

// Ad spend data from February 2026 Ad Spend CSV
const adSpendData = [
  { source: "Networx", spend: 299.98 },
  { source: "Thumbtack", spend: 8428.08 },
  { source: "Yelp", spend: 11338.37 },
  { source: "Porch", spend: 0.00 },
  { source: "Web to Lead Form", spend: 1090.00 },
  { source: "Angi", spend: 2530.00 },
  { source: "Homebuddy", spend: 1884.00 },
  { source: "RoofHero", spend: 650.00 },
  { source: "Buyerlink", spend: 0.00 },
  { source: "Lead2performance", spend: 0.00 },
  { source: "Contractors Appointments", spend: 0.00 },
  { source: "Google Organic Search", spend: 3500.00 },
  { source: "Google Paid Search", spend: 19500.00 },
  { source: "Facebook / Meta Ads", spend: 3006.49 },
  { source: "Missed Call", spend: 0.00 },
  { source: "Previous Customer", spend: 0.00 },
  { source: "Other", spend: 0.00 },
  { source: "Blank", spend: 0.00 },
  { source: "Truck", spend: 0.00 },
  { source: "Referral - From past customer", spend: 0.00 },
  { source: "DataDump GoHighLevel", spend: 0.00 },
  { source: "Referral - Word of mouth", spend: 0.00 },
  { source: "Email Campaign", spend: 0.00 },
  { source: "SpringConnect - Call Center", spend: 0.00 },
  { source: "Self Generated Lead (By Rep)", spend: 0.00 },
  { source: "BBB", spend: 300.00 },
  { source: "Events Division", spend: 9000.00 },
  { source: "Yard Sign", spend: 0.00 },
  { source: "ROI Sales Portal", spend: 0.00 },
  { source: "Modernize", spend: 0.00 },
  { source: "33 Mile Radius / Everconnect", spend: 1701.00 },
  { source: "eLocal", spend: 1500.00 }
];

const totalAdSpend = adSpendData.reduce((sum, item) => sum + item.spend, 0);

// Aggregate sales by source
const salesBySourceMap = jobData.reduce((acc, job) => {
  const source = job.leadSource;
  if (!acc[source]) {
    acc[source] = {
      source,
      totalSales: 0,
      count: 0,
      grossProfit: 0
    };
  }
  acc[source].totalSales += job.contractTotal;
  acc[source].count += 1;
  acc[source].grossProfit += job.grossProfit;
  return acc;
}, {} as Record<string, { source: string; totalSales: number; count: number; grossProfit: number }>);

const salesBySource = Object.values(salesBySourceMap).sort((a, b) => b.totalSales - a.totalSales);

// Aggregate sales by trade
const salesByTradeMap = jobData.reduce((acc, job) => {
  const trade = job.trade;
  if (!acc[trade]) {
    acc[trade] = {
      trade,
      totalSales: 0,
      count: 0,
      grossProfit: 0
    };
  }
  acc[trade].totalSales += job.contractTotal;
  acc[trade].count += 1;
  acc[trade].grossProfit += job.grossProfit;
  return acc;
}, {} as Record<string, { trade: string; totalSales: number; count: number; grossProfit: number }>);

const salesByTrade = Object.values(salesByTradeMap).sort((a, b) => b.totalSales - a.totalSales);

export const february2026Data: ReportData = {
  kpis: {
    adSpend: totalAdSpend,
    totalSales: totalContractValue,
    grossProfit: totalGrossProfit,
    salesCommissions: totalSalesCommissions,
    managerFees: totalManagerFees,
    companyOH: totalCompanyOH,
    netProfit: totalNetProfit - totalAdSpend,
    netProfitPercent: (totalNetProfit - totalAdSpend) / totalContractValue,
    grossProfitPercent: totalGrossProfit / totalContractValue
  },

  adSpendBySource: adSpendData,
  salesBySource: salesBySource,
  salesByTrade: salesByTrade,
  jobData: jobData,

  period: {
    month: 2,
    year: 2026
  }
};
